import {hasPermission, isDevEnv} from 'common/HelperFunctions'

import {AI_DATA_IMPORT_ENABLED} from './aiImport'

/**
 * Who sees AI Data Import, in the sidebar and on its route alike. The static preview stays off
 * production builds; the backend's own permission key replaces `data_upload_manager` when it ships.
 */
export const canOpenAiDataImport = (): boolean =>
  AI_DATA_IMPORT_ENABLED && isDevEnv() && hasPermission('data_upload_manager')
